import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ProductSubjectedToReverseChargeOnDocumentWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.sale.validation.items.name.product-subjected-to-reverse-charge-on-document-warning');
    }
}
